'use strict';

module.exports =  [
    "$uibModalInstance",
    "Member",
    "myTenant",
    "toast",
    function ($uibModalInstance, Member, myTenant, toast) {
      var _this = this;
      this.members = [];
      this.list = [];

      this.addUserToList = function (item) {
        item.split(",").map(function (email) {
          if (
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
              email.trim()
            )
          )
            _this.list.push(email.trim());
        });

        _this.newUser = "";
      };

      this.removeChip = function (index) {
        _this.list.splice(index, 1);
      };

      this.inviteUsers = function () {
        if (!_this.list.length) {
          return;
        }

        _this.loading = true;
        _this.new_members = [];
        let tenant = myTenant.get();

        Member.invite(
          {},
          {
            emails: _this.list,
          }
        )
          .$promise.then(function () {
            //$uibModalInstance.close();
            for (var index = 0; index < _this.list.length; ++index) {
              var email = _this.list[index];
              Member.upsert({
                email: email,
                firstName: "Por",
                lastName: "Confirmar",
                password: "xxx123456xxxx",
                tenantId: tenant.id,
                emailVerified: false,
              })
                .$promise.then(function (member) {
                  _this.new_members.push(member);

                  if (
                    member.email === _this.list[_this.list.length - 1]
                  ) {
                    setTimeout(function () {
                      $uibModalInstance.close(_this.new_members);
                      toast.success(
                        $translate.instant(
                          "DASHBOARD.DASH_WIZARD.USERS.INVITE_OK_TOAST"
                        )
                      );

                      $state.reload("dashboard").then(function () {
                        $state.go("dashboard.wizard.users", {});
                      });
                    }, 500); // xxx
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.loading = true;
          });
      };
    },
  ]